// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchBlock_wrapper__mWwD_","text":"SearchBlock_text__v1eio","count":"SearchBlock_count__fZPcS","searchInput":"SearchBlock_searchInput__BuTxw"};